import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-motion-relative-iec')
export class ObiMotionRelativeIec extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M15.011 16.9999L12.863 10.1959H12.815C12.823 10.3559 12.835 10.5919 12.851 10.9039C12.867 11.2079 12.883 11.5399 12.899 11.8999C12.915 12.2519 12.923 12.5799 12.923 12.8839V16.9999H11.375V8.43188H13.751L15.839 15.0319H15.875L18.095 8.43188H20.459V16.9999H18.839V12.8119C18.839 12.5319 18.843 12.2239 18.851 11.8879C18.867 11.5439 18.879 11.2199 18.887 10.9159C18.903 10.6039 18.915 10.3679 18.923 10.2079H18.875L16.595 16.9999H15.011Z" fill="currentColor"/>
<path d="M5.984 8.43188C6.752 8.43188 7.384 8.52788 7.88 8.71988C8.376 8.90388 8.748 9.18389 8.996 9.55989C9.244 9.93589 9.368 10.4119 9.368 10.9879C9.368 11.3879 9.292 11.7359 9.14 12.0319C8.988 12.3199 8.788 12.5639 8.54 12.7639C8.3 12.9639 8.04 13.1279 7.76 13.2559L10.256 16.9999H8.324L6.284 13.6879H5.228V16.9999H3.5V8.43188H5.984ZM5.852 9.85989H5.228V12.2719H5.888C6.296 12.2719 6.628 12.2279 6.884 12.1399C7.14 12.0439 7.324 11.9039 7.436 11.7199C7.556 11.5279 7.616 11.2999 7.616 11.0359C7.616 10.7479 7.552 10.5199 7.424 10.3519C7.296 10.1839 7.1 10.0599 6.836 9.97989C6.58 9.89989 6.252 9.85989 5.852 9.85989Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.011 16.9999L12.863 10.1959H12.815C12.823 10.3559 12.835 10.5919 12.851 10.9039C12.867 11.2079 12.883 11.5399 12.899 11.8999C12.915 12.2519 12.923 12.5799 12.923 12.8839V16.9999H11.375V8.43188H13.751L15.839 15.0319H15.875L18.095 8.43188H20.459V16.9999H18.839V12.8119C18.839 12.5319 18.843 12.2239 18.851 11.8879C18.867 11.5439 18.879 11.2199 18.887 10.9159C18.903 10.6039 18.915 10.3679 18.923 10.2079H18.875L16.595 16.9999H15.011Z" style="fill: var(--element-active-color)"/>
<path d="M5.984 8.43188C6.752 8.43188 7.384 8.52788 7.88 8.71988C8.376 8.90388 8.748 9.18389 8.996 9.55989C9.244 9.93589 9.368 10.4119 9.368 10.9879C9.368 11.3879 9.292 11.7359 9.14 12.0319C8.988 12.3199 8.788 12.5639 8.54 12.7639C8.3 12.9639 8.04 13.1279 7.76 13.2559L10.256 16.9999H8.324L6.284 13.6879H5.228V16.9999H3.5V8.43188H5.984ZM5.852 9.85989H5.228V12.2719H5.888C6.296 12.2719 6.628 12.2279 6.884 12.1399C7.14 12.0439 7.324 11.9039 7.436 11.7199C7.556 11.5279 7.616 11.2999 7.616 11.0359C7.616 10.7479 7.552 10.5199 7.424 10.3519C7.296 10.1839 7.1 10.0599 6.836 9.97989C6.58 9.89989 6.252 9.85989 5.852 9.85989Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-motion-relative-iec': ObiMotionRelativeIec;
  }
}
